import { endOfDay, startOfDay, startOfMonth, subMonths, endOfMonth, setDate, startOfQuarter, endOfQuarter, subDays, startOfWeek, endOfWeek, startOfYear, endOfYear, addMonths, addDays, getDay, getHours, parseISO, isDate, differenceInHours } from 'date-fns';
import startCase from 'lodash.startcase';
import { utcToZonedTime } from 'date-fns-tz';

function getAllPast() {
	return {
		beginDate: undefined,
		endDate: endOfDay(new Date()),
		suggestedOrderDirection: 'DESC',
	};
}

function getAllTime() {
	return {
		beginDate: undefined,
		endDate: undefined,
		suggestedOrderDirection: 'ASC',
	};
}

function getAllUpcoming() {
	return {
		beginDate: startOfDay(new Date()),
		endDate: undefined,
		suggestedOrderDirection: 'ASC',
	};
}

function getLastMonth() {
	return {
		beginDate: startOfMonth(subMonths(new Date(), 1)),
		endDate: endOfMonth(subMonths(new Date(), 1)),
		suggestedOrderDirection: 'DESC',
	};
}

function getLastPayoutPeriod() {
	const now = new Date();
	const dateOfMonth = now.getDate();

	if (dateOfMonth < 16) {
		return {
			beginDate: startOfDay(setDate(subMonths(now, 1), 16)),
			endDate: endOfMonth(subMonths(now, 1)),
			suggestedOrderDirection: 'DESC',
		};
	}

	return {
		beginDate: startOfMonth(now),
		endDate: endOfDay(setDate(now, 15)),
		suggestedOrderDirection: 'DESC',
	};
}

function getLastQuarter() {
	return {
		beginDate: startOfQuarter(subMonths(new Date(), 3)),
		endDate: endOfQuarter(subMonths(new Date(), 3)),
		suggestedOrderDirection: 'DESC',
	};
}

function getLastWeek() {
	return {
		beginDate: subDays(startOfWeek(new Date()), 7),
		endDate: subDays(endOfWeek(new Date()), 7),
		suggestedOrderDirection: 'DESC',
	};
}

function getLastYear() {
	return {
		beginDate: startOfYear(subMonths(new Date(), 12)),
		endDate: endOfYear(subMonths(new Date(), 12)),
		suggestedOrderDirection: 'DESC',
	};
}

function getMonthBeforeLast() {
	return {
		beginDate: startOfMonth(subMonths(new Date(), 2)),
		endDate: endOfMonth(subMonths(new Date(), 2)),
		suggestedOrderDirection: 'DESC',
	};
}

function getMonthToDate() {
	return {
		beginDate: startOfMonth(new Date()),
		endDate: endOfDay(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getNextMonth() {
	return {
		beginDate: startOfMonth(addMonths(new Date(), 1)),
		endDate: endOfMonth(addMonths(new Date(), 1)),
		suggestedOrderDirection: 'ASC',
	};
}

function getNextPayoutPeriod() {
	const now = new Date();
	const dateOfMonth = now.getDate();

	if (dateOfMonth < 16) {
		return {
			beginDate: startOfDay(setDate(now, 16)),
			endDate: endOfMonth(now),
			suggestedOrderDirection: 'ASC',
		};
	}

	return {
		beginDate: startOfMonth(addMonths(now, 1)),
		endDate: endOfDay(setDate(addMonths(now, 1), 15)),
		suggestedOrderDirection: 'ASC',
	};
}

function getNextQuarter() {
	return {
		beginDate: startOfQuarter(addMonths(new Date(), 3)),
		endDate: endOfQuarter(addMonths(new Date(), 3)),
		suggestedOrderDirection: 'ASC',
	};
}

function getNextWeek() {
	return {
		beginDate: addDays(startOfWeek(new Date()), 7),
		endDate: addDays(endOfWeek(new Date()), 7),
		suggestedOrderDirection: 'ASC',
	};
}

function getNextYear() {
	return {
		beginDate: startOfYear(addMonths(new Date(), 12)),
		endDate: endOfYear(addMonths(new Date(), 12)),
		suggestedOrderDirection: 'ASC',
	};
}

function getQuarterToDate() {
	return {
		beginDate: startOfQuarter(new Date()),
		endDate: endOfDay(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getThisMonth() {
	return {
		beginDate: startOfMonth(new Date()),
		endDate: endOfMonth(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getThisPayoutPeriod() {
	const now = new Date();
	const dateOfMonth = now.getDate();

	if (dateOfMonth < 16) {
		return {
			beginDate: startOfMonth(now),
			endDate: endOfDay(setDate(now, 15)),
			suggestedOrderDirection: 'ASC',
		};
	}

	return {
		beginDate: startOfDay(setDate(now, 16)),
		endDate: endOfMonth(now),
		suggestedOrderDirection: 'ASC',
	};
}

function getThisQuarter() {
	return {
		beginDate: startOfQuarter(new Date()),
		endDate: endOfQuarter(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getThisWeek() {
	return {
		beginDate: startOfWeek(new Date()),
		endDate: endOfWeek(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getThisYear() {
	return {
		beginDate: startOfYear(new Date()),
		endDate: endOfYear(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getToday() {
	return {
		beginDate: startOfDay(new Date()),
		endDate: endOfDay(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getTomorrow() {
	return {
		beginDate: addDays(startOfDay(new Date()), 1),
		endDate: addDays(endOfDay(new Date()), 1),
		suggestedOrderDirection: 'ASC',
	};
}

function getUpcomingWeek(beginDate = new Date()) {
	return {
		beginDate: startOfDay(beginDate),
		endDate: addDays(endOfDay(beginDate), 6),
		suggestedOrderDirection: 'ASC',
	};
}

function getYearToDate() {
	return {
		beginDate: startOfYear(new Date()),
		endDate: endOfDay(new Date()),
		suggestedOrderDirection: 'ASC',
	};
}

function getYesterday() {
	return {
		beginDate: subDays(startOfDay(new Date()), 1),
		endDate: subDays(endOfDay(new Date()), 1),
		suggestedOrderDirection: 'DESC',
	};
}

const dateRangeFunctions = {
	getAllPast,
	getAllTime,
	getAllUpcoming,
	getLastMonth,
	getLastPayoutPeriod,
	getLastQuarter,
	getLastWeek,
	getLastYear,
	getMonthBeforeLast,
	getMonthToDate,
	getNextMonth,
	getNextPayoutPeriod,
	getNextQuarter,
	getNextWeek,
	getNextYear,
	getQuarterToDate,
	getThisMonth,
	getThisPayoutPeriod,
	getThisQuarter,
	getThisWeek,
	getThisYear,
	getToday,
	getTomorrow,
	getUpcomingWeek,
	getYearToDate,
	getYesterday,
};

function getDateRangeForPreset(preset) {
	const functionToCall =
		dateRangeFunctions[
			`get${startCase(preset).replace(new RegExp(/\s/g), '')}`
		];

	if (typeof functionToCall === 'function') {
		return functionToCall();
	}

	throw new Error(
		'The preset you passed cannot be converted into a date range.  Please try another preset.'
	);
}

/**
 * @description Given a date, determine if it is valid.
 * @param {string|Date} date - The date to validate.
 * @return {boolean} Whether or not the provided date is valid.
 */
function isDateValid(date) {
	if (typeof date !== 'string' && !(date instanceof Date)) {
		throw new Error(
			'The date parameter provided is not a string or Date. Please pass a string or Date.'
		);
	}

	if (date instanceof Date) {
		return date.toString() !== 'Invalid Date';
	}

	return !isNaN(Date.parse(date));
}

/**
 * @description Given `date` and `timezone`, determine the time of day.
 * @param {string|Date} date - The date to determine the time of day from.
 * @param {string} timezone - The time zone of the date.
 * @return {object} An object indicating the time of day.
 */
function getTimeOfDay(date, timezone) {
	if (typeof timezone !== 'string') {
		throw new Error(
			'The timezone parameter provided is not a string. Please pass a string'
		);
	}

	if (!isDateValid(date)) {
		throw new Error(
			'The date parameter provided is not valid. Please pass a valid date.'
		);
	}

	date = utcToZonedTime(date, timezone);
	const day = getDay(date);
	const hour = getHours(date);

	let timeOfDay;
	const isWeekday = day !== 0 && day !== 6;

	if (hour >= 7 && hour < 10) {
		timeOfDay = 'morning';
	} else if (hour >= 10 && hour < 15) {
		timeOfDay = 'noon';
	} else if (hour >= 15 && hour < 19) {
		timeOfDay = 'evening';
	} else {
		timeOfDay = 'night';
	}

	return {
		isWeekday,
		timeOfDay,
	};
}

/**
 * @description Given a date string or Date object, return its Date object representation.
 * @param {string|Date} date - The date to convert to a Date object.
 * @return {Date} The Date object representation of the provided `date`.
 */
function getValidDate(date) {
	const dateIsValid = isDateValid(date);

	if (!dateIsValid) {
		throw new Error(
			'The date parameter provided is not a valid date string or Date object. Please pass a valid date string or Date object.'
		);
	}

	if (typeof date === 'string') {
		return parseISO(date);
	} else if (isDate(date)) {
		return date;
	}
}

/**
 * @description Given two dates, determine if the two dates are within a number of hours of one another.
 * @param {string|Date} laterDate The later of the two dates to compare.
 * @param {string|Date} earlierDate The earlier of the two dates to compare.
 * @param {number} maxDifferenceInHours The maximum number of hours allowed between `laterDate` and `earlierDate`.
 * @param {boolean} normalizeToEndOfDay Whether or not to normalize the dates to the end of their respective days.  This is helpful if you want to do something like a 24 hour comparison where the two dates can be more than 24 hours apart, but the end of their respective days aren't.
 * @return {boolean} Whether or not the two dates are within the `maxDifferenceInHours` of one another.
 */
function isWithinHours(
	laterDate,
	earlierDate,
	maxDifferenceInHours,
	normalizeToEndOfDay = false
) {
	const normalizedLaterDate = normalizeToEndOfDay
		? endOfDay(getValidDate(laterDate))
		: getValidDate(laterDate);
	const normalizedEarlierDate = normalizeToEndOfDay
		? endOfDay(getValidDate(earlierDate))
		: getValidDate(earlierDate);

	return (
		differenceInHours(normalizedLaterDate, normalizedEarlierDate) <=
		maxDifferenceInHours
	);
}

export { getAllPast, getAllTime, getAllUpcoming, getDateRangeForPreset, getLastMonth, getLastPayoutPeriod, getLastQuarter, getLastWeek, getLastYear, getMonthBeforeLast, getMonthToDate, getNextMonth, getNextPayoutPeriod, getNextQuarter, getNextWeek, getNextYear, getQuarterToDate, getThisMonth, getThisPayoutPeriod, getThisQuarter, getThisWeek, getThisYear, getTimeOfDay, getToday, getTomorrow, getUpcomingWeek, getValidDate, getYearToDate, getYesterday, isDateValid, isWithinHours };
